import Vue from 'vue';
import Vuex from 'vuex';
//import {localSt} from "@/store/localStorage.js";
import {instance, api} from "@/store/api";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {

		loaderList: [],
		token: '',
		user: null,
		messages: [],
		/*player_settings: localSt.fetch('player_settings')*/


		stream: {
			id: null,
			data: null
		}
	},
	mutations: {
		setCSRFtoken(state, token){
			state.token = token;
		},

		/** Loader
		 *
		  * */
		addLoad(state, loadName) {

			if (state.loaderList.indexOf(loadName) === -1) {
				state.loaderList.push(loadName);
			}
		},
		endLoad(state, loadName) {

			let indx = state.loaderList.indexOf(loadName);
			if (indx > -1) {
				state.loaderList.splice(indx, 1);
				//_.remove(state.loaderList,  el => el === loadName);
			}
		},

		/**
		 * Messages
		 * */

		deleteMessage(state, scope){

			state.messages = state.messages.filter((el)=>{
				return el.scope !== scope;
			});
		},
		addMessage(state, data){

			state.messages.push(data);

		},
		addMessages(state, data){

			data.messages.forEach((el)=>{
				el.scope = data.scope;
				el.type = data.type;
				state.messages.push(el);
			})


		},

		/*setPlayerSettings(state, value){
			//Format
			/!*
			*
			* {
			*   preferred: rtmp/hls
			*
			* }
			*
			* *!/


			localSt.save('player_settings', value);
			state.player_settings = value;
		}*/

		gotUser(state, user){
			if(user){
				state.user = user;
			}
		},
		clearUser(state){
			state.user = null;
		},



		/**
		 * Streams
		 * */

		setStream(store, id){

			store.stream.id = id;
			store.stream.data = null;
			this.dispatch('getStream', id);
		},
		gotStream(store, data){

			if(data){

				store.stream.data = data;
			}
		},
		gotChannels(store, data){

			if(data.channels){

				store.user.channels = data.channels;
			}
		}

	},
	getters:{
		csrf_token(state){
			return state.token;
		},

		user(state){
			return state.user;
		},
		isLoggedIn(state){
			return state.user !== null;
		},

		getMessage(state){
			return scope => state.messages.filter((el)=>{
				return el.scope === scope;
			});
		},
		stream(state){

			if(state.stream.data){


				if(state.stream.data.url || state.stream.data.hlsurl){
					return {
						id: state.stream.data.streamId,
						type: 'player',
						stream: {
							rtmp: state.stream.data.url,
							hls: state.stream.data.hlsurl
						}
					};
				}else if(state.stream.data.iframeUrl){
					return {
						id: state.stream.data.streamId,
						type: 'iframe',
						url: state.stream.data.iframeUrl
					};
				}


			}

			return null;
		},
		channels(state){
			if(state.user){
				return state.user.channels;
			}else{
				return [];
			}
		}
	},
	actions: {


		/**
		 * User stuff
		 */
		userRefreshAction({commit}){
			let scope = 'userRefresh';
			commit('addLoad', scope);
			return instance.post(api.user.refresh).then((response)=>{

				if(response.data && response.data.username){
					commit('gotUser', response.data);
				}
				commit('endLoad', scope);

				Promise.resolve(response);
				return response;
			}).catch(({response})=>{

				commit('clearUser');
				if(response.data.errors){
					commit('addMessages', {
						scope: scope,
						type: 'danger',
						messages: response.data.errors
					});
				}

				commit('endLoad', scope);
				return response;

			});
		},
		postAuth({commit}, params){

			commit('addLoad', params.scope);
			commit('deleteMessage', params.scope);

			return instance.post(api.user.login, params).then(({data})=>{

				if(data && data.username){
					commit('gotUser', data);
				}
				commit('endLoad', params.scope);

				return data;
			}).catch(({response})=>{

				if(response.data && response.data.errors){
					commit('addMessages', {
						scope: params.scope,
						type: 'danger',
						messages: response.data.errors
					});
				}


				commit('endLoad', params.scope);
				return response;

			});
		},
		postLogout({commit}){
			let scope = 'postAuth';


			commit('addLoad', scope);
			commit('deleteMessage', scope);

			return instance.post(api.user.logout).then(({data})=>{

				commit('clearUser');

				commit('endLoad', scope);

				return data;
			}).catch(({response})=>{

				if(response.data.errors){
					commit('addMessages', {
						scope: scope,
						type: 'danger',
						messages: response.data.errors
					});
				}

				commit('endLoad', scope);
				return response;

			})
		},


		/**
		 * Stream
		 */

		getStreams({commit}){
			const scope = 'general-streams';
			commit('addLoad', scope);
			commit('deleteMessage', scope);

			return instance.post(api.streams.chanels).then(({data})=>{

				commit('gotChannels', data);
				commit('endLoad', scope);
				return data;
			}).catch(({response})=>{
				commit('endLoad', scope);
				if(response.data.errors){
					commit('addMessages', {
						scope: 'general-streams',
						type: 'danger',
						messages: response.data.errors
					});
				}

				return response;

			});

		},
		getStream({commit}, id){
			const scope = 'general-streams';
			commit('addLoad', scope+'_1');

			commit('deleteMessage', scope);


			return instance.post(api.streams.stream+id).then(({data})=>{

				commit('gotStream', data);
				commit('endLoad', scope+'_1');

				return data;
			}).catch(({response})=>{

				commit('endLoad', scope+'_1');

				if(response.data.errors){
					commit('addMessages', {
						scope: 'general-streams',
						type: 'danger',
						messages: response.data.errors
					});
				}

				return response;

			});




		}

	}
});
